export const statusPropostasEnum = {
  emProcessamento: "Em Processamento",
  rejeitado: "Rejeitada",
  editada: "Editada",
  aprovado: "Aprovada",
  execucaoIniciada: "Em execução",
};
